import { MipsEligibilityResponse } from "@models/mips-stepper.model";
import { createFeature, createReducer, on } from "@ngrx/store";
import { MipsEligibilityActions } from "@store/actions/mips-eligibility/mips-eligibility.actions";

export const mipsEligibilityFeatureKey = "mipsEligibility";

export interface State {
  eligibilityResult: MipsEligibilityResponse | null;

  isCheckingEligibility: boolean;
  eligibilityError: string | null;

  batchEligibilityResults: MipsEligibilityResponse[];
  isCheckingBatch: boolean;
  batchError: string | null;
}

export const initialState: State = {
  eligibilityResult: null,
  isCheckingEligibility: false,
  eligibilityError: null,
  batchEligibilityResults: [],
  isCheckingBatch: false,
  batchError: null,
};

export const reducer = createReducer(
  initialState,

  on(MipsEligibilityActions.checkEligibility, (state) => ({
    ...state,
    isCheckingEligibility: true,
    eligibilityError: null,
  })),
  on(MipsEligibilityActions.checkEligibilitySuccess, (state, { result }) => ({
    ...state,
    eligibilityResult: result,
    isCheckingEligibility: false,
    eligibilityError: null,
  })),
  on(MipsEligibilityActions.checkEligibilityFailure, (state, { error }) => ({
    ...state,
    isCheckingEligibility: false,
    eligibilityError: error,
  })),
  on(MipsEligibilityActions.selectOrganization, (state, { organization }) => ({
    ...state,
    eligibilityResult: state.eligibilityResult
      ? {
          ...state.eligibilityResult,
          npi: organization.npi,
          clinicianName: organization.clinicianName,
          organizationName: organization.organizationName,
          individualEligible: organization.individualEligible,
          groupEligible: organization.groupEligible,
          subgroupEligible: organization.subgroupEligible,
          individualOptInEligible: organization.individualOptInEligible,
          groupOptInEligible: organization.groupOptInEligible,
          subgroupOptInEligible: organization.subgroupOptInEligible,
          performanceYear: organization.performanceYear,
          eligibilityReason: organization.eligibilityReason,
        }
      : null,
  })),
  on(MipsEligibilityActions.clearEligibilityResults, (state) => ({
    ...state,
    eligibilityResult: null,
    eligibilityError: null,
  })),
  on(MipsEligibilityActions.checkBatchEligibility, (state) => ({
    ...state,
    isCheckingBatch: true,
    batchError: null,
  })),
  on(
    MipsEligibilityActions.checkBatchEligibilitySuccess,
    (state, { results }) => ({
      ...state,
      batchEligibilityResults: results,
      isCheckingBatch: false,
      batchError: null,
    })
  ),
  on(
    MipsEligibilityActions.checkBatchEligibilityFailure,
    (state, { error }) => ({
      ...state,
      isCheckingBatch: false,
      batchError: error,
    })
  )
);

export const mipsEligibilityFeature = createFeature({
  name: mipsEligibilityFeatureKey,
  reducer,
});
